import React, { useContext } from 'react';
import { AppSidebar, AppSidebarMenuItem } from '@redpanda/ui';
import {
  UsersIcon,
  ClockIcon,
  BanknotesIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';
import ThemeSelector from './ThemeSelector';
import { UserContext } from '../context/UserContext';
import { useTranslation } from 'react-i18next';
import { isAdmin } from '@redpanda/utils';

interface SidebarProps {
  className?: string;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const menuItems: AppSidebarMenuItem[] = [
  { path: '/employees', labelKey: 'navbar.employees', icon: UsersIcon },
  { path: '/attendance', labelKey: 'navbar.attendance', icon: ClockIcon },
  { path: '/payroll', labelKey: 'navbar.payroll', icon: BanknotesIcon },
  { path: '/reports', labelKey: 'navbar.reports', icon: ChartBarIcon },
];

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { user, logout, updateUserLanguage, language } = useContext(UserContext)!;
  const { i18n } = useTranslation();

  return (
    <AppSidebar
      appName="RedPanda HR"
      logoPath="/employees"
      // 薪資只給管理員（一般使用者只處理員工、出勤、請假）
      menuItems={isAdmin(user?.role) ? menuItems : menuItems.filter(item => item.path !== '/payroll')}
      user={user}
      currentLanguage={language || i18n.language}
      onLanguageChange={(lng) => {
        if (updateUserLanguage) updateUserLanguage(lng as 'zh' | 'en' | 'ja');
        else i18n.changeLanguage(lng);
      }}
      onLogout={logout}
      themeSelector={<ThemeSelector />}
      currentSystem="HR"
      {...props}
    />
  );
};

export default Sidebar;
